module.exports = __webpack_public_path__ + "static/media/vuepress.d1fed5cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-alternatives/images/vuepress.png
// module id = 966
// module chunks = 0